export default {
  expensesFor: 'Expenses for {month}',
  clickTooltip: 'Click a name for more details',
  name: 'Name',
  days: 'Days',
  paidCost: 'Price to Pay',
  actualCost: 'Cost',
  hasUserPaid: 'Paid',
  hasUserNotPaid: 'Not paid',
  userPaidDialogTitle: 'Please confirm',
  userPaidDialogText: 'Has the user {displayName} paid {paidCost}€?',
  userPaidDialogUndoText: 'User {displayName} has already paid for the chosen period. Are you sure you want to undo this?',
  userPaidDialogName: 'User',
  userPaidDialogAmount: 'Amount paid',
  userPaidDialogDate: 'Period',
  allUsersPaid: 'Everyone has paid!',
  sendPayReminder: 'Send reminder',
  total: 'Total cost: {total}€',
  totalToCollect: 'Amount to collect: {total}€',
  intervalTypeFullMonth: 'Full Month',
  intervalTypeFirstHalf: 'First Half',
  intervalTypeSecondHalf: 'Second Half',
};
